import classNames from "classnames";
import { DComponent } from "../DComponent";
export default class AddToCartBtn extends DComponent {
  constructor({
    parent,
    id,
    className,
    textAddTo,
    textDutycastCart,
    textAddToHide,
    textHide,
    textAddToDraft,
    textDraft,
    addIcon,
    addedIcon,
    collapseIcon,
    arrowCollapse,
    arrowExpand,
    dragIcon,
    state,
    onCollapse = (value, originalEvent) => { },
    onClick = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AddToCartBtn", className, `dc-${state}`),
      textAddTo,
      textDutycastCart,
      textAddToHide,
      textHide,
      textAddToDraft,
      textDraft,
      addIcon,
      addedIcon,
      collapseIcon,
      arrowCollapse,
      arrowExpand,
      dragIcon,
      state,
    }, true, true);
    this.onCollapse = onCollapse;
    this.onClick = onClick;
    this.state = state;
    this.render();
  }

  static init({
    parent,
    id,
    className,
    textAddTo,
    textDutycastCart,
    textAddToHide,
    textHide,
    textAddToDraft,
    textDraft,
    addIcon,
    addedIcon,
    collapseIcon,
    arrowCollapse,
    arrowExpand,
    dragIcon,
    state,
    onCollapse = (value, originalEvent) => { },
    onClick = (e) => { },
  } = {}) {
    return new AddToCartBtn({
      parent,
      id,
      className,
      textAddTo,
      textDutycastCart,
      textAddToHide,
      textHide,
      textAddToDraft,
      textDraft,
      addIcon,
      addedIcon,
      collapseIcon,
      arrowCollapse,
      arrowExpand,
      dragIcon,
      state,
      onCollapse,
      onClick,
    });
  }

  loadStyle() {
    const style = document.createElement("style");
    style.textContent = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.element.append(style);
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.element.on("click", ".dc-icon.collapse", (e) => {
      typeof e.preventDefault == "function" && e.preventDefault();
      this.element.removeClass("collapseItem").removeClass("expandItem").addClass("collapseItem");
      typeof this.onCollapse === "function" && this.onCollapse(true, e.originalEvent);
    });

    this.element.on("click", ".dc-icon.expand", (e) => {
      typeof e.preventDefault == "function" && e.preventDefault();
      this.element.removeClass("collapseItem").removeClass("expandItem").addClass("expandItem");
      typeof this.onCollapse === "function" && this.onCollapse(false, e.originalEvent);
    });

    this.element.on('click', ".dc-box-cart", (e) => {
      typeof e.preventDefault == "function" && e.preventDefault();
      typeof this.onClick === "function" && this.onClick(e);
    });
  }

  setState(state) {
    this.element.removeClass(`dc-${this.state}`).addClass(`dc-${state}`);
    this.state = state;
  }

  collapse(value) {
    this.element.removeClass("collapseItem").removeClass("expandItem").addClass(value ? "collapseItem" : "expandItem");
  }

  collapseClick() {
    this.element.find("> .dc-icon:visible").trigger("click");
  }

  isCollapse() {
    return this.element.hasClass("collapseItem");
  }

  disableUI(value = true) {
    this.element.removeClass("dc-disabled1");
    value && this.element.addClass("dc-disabled1");
  }

  disableClick(value = true) {
    this.element.removeClass("dc-disabled2");
    value && this.element.addClass("dc-disabled2s");
  }

  added(value) {
    value ? this.element.find(".dc-box-cart").addClass("added") : this.element.find(".dc-box-cart").removeClass("added");
  }

  setText(textAddTo, textDutycastCart, textAddToHide, textHide, textAddToDraft, textDraft) {
    $(".dc-box-cart", this.element).attr("title", `${textAddTo} ${textDutycastCart}`);
    $(".dc-highlight-hide", this.element).html(textAddToHide);
    $(".dc-message-hide", this.element).html(textHide);
    $(".dc-highlight-draft", this.element).html(textAddToDraft);
    $(".dc-message-draft", this.element).html(textDraft);
    $(".dc-highlight", this.element).html(textAddTo);
    $(".dc-message", this.element).html(textDutycastCart);
  }
}
